import { computed, defineComponent, onMounted, Ref, ref, version, reactive } from "vue";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toast from "primevue/toast";

import ForgotPassword from "./ForgotPassword.vue";
import Cargando from "../../../../../common/infrastructure/componentes/base/common/cargando/Cargando.vue";
import logoComp from "../../../../../common/infrastructure/funcionescompartidas/logoComp";
import { authRequest } from "../../domain/authRequest";
import HelperCommon from "../../../../../common/infrastructure/funciones/HelperCommon";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { IServiceAuth } from "../../application/IServiceAuth";
import { TYPES } from "../../../../../common/domain/types";
import Swal from "sweetalert2";
import { Container } from "inversify";
import { Router } from "vue-router";
import {
  Actions,
  Mutations,
} from "../../../../../common/infrastructure/almacen/enums/StoreEnums";
import { CookieService } from "../../../../../common/infrastructure/servicios";
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";
import AunnaApplicationConst from "@ilinium/shared/src/common/domain/constantes/Applications/AunnaApplicationConst";
import AllianceApplicationConst from "@ilinium/shared/src/common/domain/constantes/Applications/AllianceApplicationConst";
import IliniumApplicationConst from "@ilinium/shared/src/common/domain/constantes/Applications/IliniumApplicationConst";
import WillisApplicationConst from "@ilinium/shared/src/common/domain/constantes/Applications/WillisApplicationConst";
import IntrasoftApplicationConst from "@ilinium/shared/src/common/domain/constantes/Applications/IntrasoftApplicationConst";
import PerisApplicationConst from "@ilinium/shared/src/common/domain/constantes/Applications/PerisApplicationConst";
import { IapMenu } from "../../../../builder/menu/domain/iapMenu";
import { CustomMenu } from "../../../../../common/domain/modelos/menu/CustomMenu";
import { MenuItem } from "primevue/menuitem";
import HelperLogin from "./HelperLogin";
import Environment from "../../../../../common/domain/constantes/environment";
import { appConfig } from "../../domain/appConfig";
import { appConfigResponse } from '../../domain/appConfigResponse'
import { IapCatalog } from "../../../../builder/catalog/domain/iapCatalog";
import { RefSymbol } from "@vue/reactivity";
import CatalogConfigurationConst from '@ilinium/shared/src/entidades/builder/catalog/domain/const/CatalogConfigurationConst';
import CatalogTypeConst from "../../../../builder/catalog/domain/const/CatalogTypeConst";
import { getCatalogsFromService } from "../../../../builder/catalog/infrastructure/helper/helperCatalog";
import HelperLoading from "../../../../../common/infrastructure/funciones/HelperLoading";

export default function loginComp(
  ipublicPath: any,
  routes: any,
  container: Container,
  showModalAuthType: Ref<boolean>,
  props: any,
  store:any
) {
  const { getLogoPanelUrl, getLogoUrl, getFaviconUrl} = logoComp();

  
  const submitButton = ref<HTMLElement | null>(null);
  const bodyLogin = ref<HTMLElement | null>(null);
  const emailControl = ref<HTMLElement | null>(null);
  const pwdControl = ref<HTMLElement | null>(null);
  let isLoading = ref<boolean>(false);
  let index = 0;
  const isForgetPass = ref(false);
  const submitted = ref(false);
  const version = ref("");

  const appCfgRsp = ref<appConfigResponse>();
  const appCfg = reactive<appConfig> ({version:"",color1:"",color2:"",favicon:"",language:"",logopng:"",logosvg:"",template:"",theme:"",style:"",templateConfig:false,templateConfigSimple:true,urlreport:""});
  const appCatalog = ref<IapCatalog[]> ([])

  const request = ref<authRequest>({
    grant_type: "password",
    username: "",
    password: "",
    client_id: "",
    client_secret: "",
    refresh_token: "",
    brokerId: null,
    profileId: "",
    applicationId: Environment.APPID,
    applicationVersion: Environment.APPVERSION,
    external: process.env.VUE_APP_PLATFORM == 'peris' || process.env.VUE_APP_PLATFORM == 'willis' 
  });

  const customEmail = (value: string) => {
    return HelperCommon.validarEmail(value);
  };

  const rules = {
    password: {
      required: helpers.withMessage("El password es obligatorio", required),
    },
    username: {
      required: helpers.withMessage("El usuario es obligatorio", required),
      customEmail: helpers.withMessage("Correo no válido", customEmail),
    },
  };

  const v$ = useVuelidate(rules, request);

  const getVersion = () => {
    HelperLoading.showLoading();
    const _srvAuth = container?.get<IServiceAuth>(TYPES.AUTH_SERVICE);
    _srvAuth
      ?.getVersion()
      .then((response: any) => {
        version.value = response.data.data;
        //platform.value = data.platform;
      })
      .finally(() => {
        HelperLoading.hideLoading();
      });
  };

  const getAppConfig = () => {
    HelperLoading.showLoading();
    const _srvAuth = container?.get<IServiceAuth>(TYPES.AUTH_SERVICE);
    _srvAuth
      ?.getAppConfig(Environment.APPID, Environment.APPVERSION)
      .then((response: any) => {
        appCfgRsp.value = response.data;
        appCfg.version = response.data.data.app.appVersion       
        let cfgArray = response.data.data.appConfiguration
        appCatalog.value = response.data.data.appCatalog

        // se añade la configuración al storage
        store.commit(Mutations.SET_APPCONFIG, cfgArray?.filter((x:any) => (x.keyBinaryValue ?? '') == '') ?? [])

        // Se añade el Catalogo de la configuración al storage
        store.commit(Mutations.SET_APPCONFIGCATALOG, appCatalog.value); 

        // AppConfig
        for (let idx = 0; idx < cfgArray.length; idx++) {
          const element = cfgArray[idx];
          if (element.idKeyType == CatalogConfigurationConst.COLOR1)
            appCfg.color1 = element.keyValue
          if (element.idKeyType == CatalogConfigurationConst.COLOR2)
            appCfg.color2 = element.keyValue
          if (element.idKeyType == CatalogConfigurationConst.FAVICON)
            appCfg.favicon = element.keyBinaryValue
          if (element.idKeyType == CatalogConfigurationConst.LANGUAGE)
            appCfg.language = element.keyValue
          if (element.idKeyType == CatalogConfigurationConst.LOGOPNG)
            appCfg.logopng = element.keyBinaryValue
          if (element.idKeyType == CatalogConfigurationConst.LOGOSVG)
            appCfg.logosvg = element.keyBinaryValue
          if (element.idKeyType == CatalogConfigurationConst.TEMPLATE)
            appCfg.template = element.keyValue
          if (element.idKeyType == CatalogConfigurationConst.TEMPLATETHEME)
            appCfg.theme = element.keyValue            
          if (element.idKeyType == CatalogConfigurationConst.TEMPLATETHEMESTYLE)
            appCfg.style = element.keyValue            

          if (element.idKeyType == CatalogConfigurationConst.TEMPLATECONFIG)
            appCfg.templateConfig = element.keyValue            
          if (element.idKeyType == CatalogConfigurationConst.TEMPLATECONFIGSIMPLE)
            appCfg.templateConfigSimple = element.keyValue            

          if (element.idKeyType ==  CatalogConfigurationConst.URLREPORTLAUNCHER)
            appCfg.urlreport = element.keyValue            
        }
      })
      .finally(() => {
        HelperLoading.hideLoading();
      });
  };

  onMounted(() => {
    getAppConfig();
    getVersion();
    pageLoad();
  });

  const handleSubmit = (isFormValid: boolean) => {
    submitted.value = true;

    if (!isFormValid) {
      return;
    }
  };

  const isValidLoginData = (): boolean => {
    submitted.value = true;
    v$.value.$touch();
    if (v$.value.$invalid) {
      HelperCommon.setFocusOnFirstError();
      return false;
    }

    return true;
  };
  const showLoading = computed(() => {
    return isLoading.value;
  });

  //Form submit function
  const onSubmitLogin = () => {
    if (isValidLoginData()) {
      setTimeout(() => {
        isLoading.value = true;
        HelperLoading.showLoading();
        store
          .dispatch(Actions.AUTH, [request, container])
          .then(() => {
            getCatalogsFromService(props.container, Environment.APPID,Environment.APPVERSION).then(response => {
              if (response) {
                HelperLogin.getApplicationMenus(true, routes, Environment.APPID,Environment.APPVERSION, container, '');
              }
            
          })
        })
          .finally(() => {
            isLoading.value = false;
            HelperLoading.hideLoading();
          });
      }, 500);
    }
  };

  const onSubmitForgotPassword = () => {
    //show.value = true;
    // Dummy delay
    /*setTimeout(() => {
            // Send login request
            store.dispatch(Actions.FORGOT_PASSWORD, request.value).then(() => {
                router.push({ name: 'mipanel' });
            });

            //Deactivate indicator
        }, 100);*/
    /*
        setTimeout(() => {
            // Send login request
            store.dispatch(Actions.REGISTER, [{email: 'gilberto@intrasoft.es'}, Container]).then(() => {
                routes?.push({ name: 'mipanel' });
            });

            //Deactivate indicator
        }, 100);*/
  };

  function pageLoad() {
    carousel();
  }

  function carousel() {
    if (
      routes?.currentRoute.value.path == "/login" &&
      bodyLogin.value != null
    ) {
      if (index > 5) {
        index = 0;
      }
      index++;
      if (index === 1) {
        bodyLogin.value.style.background =
          "url(" +
          ipublicPath +
          "layout/images/pages/login/bgil1.jpg) center top / cover no-repeat fixed";
      } else if (index === 2) {
        bodyLogin.value.style.background =
          "url(" +
          ipublicPath +
          "layout/images/pages/login/bgil2.jpg) center top / cover no-repeat fixed";
      } else if (index === 3) {
        bodyLogin.value.style.background =
          "url(" +
          ipublicPath +
          "layout/images/pages/login/bgil3.jpg) center top / cover no-repeat fixed";
      } else if (index === 4) {
        bodyLogin.value.style.background =
          "url(" +
          ipublicPath +
          "layout/images/pages/login/bgil4.jpg) center top / cover no-repeat fixed";
      } else {
        bodyLogin.value.style.background =
          "url(" +
          ipublicPath +
          "layout/images/pages/login/bgil5.jpg) center top / cover no-repeat fixed";
      }
    }
    setTimeout(carousel, 30000);
  }

  return {
    request,
    onSubmitLogin,
    onSubmitForgotPassword,
    submitButton,
    bodyLogin,
    carousel,
    pageLoad,
    isForgetPass,

    emailControl,
    pwdControl,
    showLoading,
    isLoading,
    ipublicPath,
    v$,
    isValidLoginData,
    submitted,
    handleSubmit,
    version,
    getLogoPanelUrl,
    getLogoUrl,
    getFaviconUrl,
    getVersion,    
    appCfg,
    appCatalog
  };
}
